'use strict';

function updateFilterStatus ($marketingChecklist) {
  var $filter = $marketingChecklist.find('#marketing-checklist-filter');

  $filter.find('.dropdown-menu li').each(function () {
    var count = parseInt($('.badge', this).text(), 10);
    $(this).toggleClass('disabled', count === 0);
  });
}

module.exports = updateFilterStatus;
